<template>
  <div class="partner">
    <div class="name">合作伙伴</div>
    <div class="border"></div>
    <!--        <div class="lable">专注于区块链行业 自主研发技术领先</div>-->
    <div class="content">
      <img
        v-for="(item, index) in imgs"
        :key="index"
        :src="imgUrl['url' + index]"
        alt=""
        @mouseover="mouseover(index)"
        @mouseout="mouseout(index)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "cooperative-partner",
  data() {
    return {
      imgs: [
        {
          url1: require("./../../assets/home/partner/1/1.png"),
          url2: require("./../../assets/home/partner2/1/1.png"),
        },
        {
          url1: require("./../../assets/home/partner/1/2.jpg"),
          url2: require("./../../assets/home/partner2/1/2.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/1/3.jpg"),
          url2: require("./../../assets/home/partner2/1/3.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/1/4.jpg"),
          url2: require("./../../assets/home/partner2/1/4.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/1/5.jpg"),
          url2: require("./../../assets/home/partner2/1/5.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/2/1.jpg"),
          url2: require("./../../assets/home/partner2/2/1.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/2/2.jpg"),
          url2: require("./../../assets/home/partner2/2/2.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/2/3.jpg"),
          url2: require("./../../assets/home/partner2/2/3.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/2/4.jpg"),
          url2: require("./../../assets/home/partner2/2/4.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/2/5.jpg"),
          url2: require("./../../assets/home/partner2/2/5.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/2/6.jpg"),
          url2: require("./../../assets/home/partner2/2/6.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/2/7.jpg"),
          url2: require("./../../assets/home/partner2/2/7.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/2/8.jpg"),
          url2: require("./../../assets/home/partner2/2/8.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/2/QBS.jpg"),
          url2: require("./../../assets/home/partner2/2/QBS.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/3/1.png"),
          url2: require("./../../assets/home/partner2/3/1.png"),
        },
        {
          url1: require("./../../assets/home/partner/3/2.png"),
          url2: require("./../../assets/home/partner2/3/2.png"),
        },
        {
          url1: require("./../../assets/home/partner/3/3.jpg"),
          url2: require("./../../assets/home/partner2/3/3.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/3/4.jpg"),
          url2: require("./../../assets/home/partner2/3/4.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/3/5.jpg"),
          url2: require("./../../assets/home/partner2/3/5.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/3/6.png"),
          url2: require("./../../assets/home/partner2/3/6.png"),
        },
        {
          url1: require("./../../assets/home/partner/4/1.png"),
          url2: require("./../../assets/home/partner2/4/1.png"),
        },
        {
          url1: require("./../../assets/home/partner/4/2.jpg"),
          url2: require("./../../assets/home/partner2/4/2.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/4/3.jpg"),
          url2: require("./../../assets/home/partner2/4/3.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/5/1.png"),
          url2: require("./../../assets/home/partner2/5/1.png"),
        },
        {
          url1: require("./../../assets/home/partner/5/2.png"),
          url2: require("./../../assets/home/partner2/5/2.png"),
        },
        {
          url1: require("./../../assets/home/partner/5/3.jpg"),
          url2: require("./../../assets/home/partner2/5/3.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/5/4.png"),
          url2: require("./../../assets/home/partner2/5/4.png"),
        },
        {
          url1: require("./../../assets/home/partner/5/5.jpg"),
          url2: require("./../../assets/home/partner2/5/5.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/5/6.jpg"),
          url2: require("./../../assets/home/partner2/5/6.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/5/7.jpg"),
          url2: require("./../../assets/home/partner2/5/7.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/6/1.jpg"),
          url2: require("./../../assets/home/partner2/6/1.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/6/2.jpg"),
          url2: require("./../../assets/home/partner2/6/2.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/6/3.jpg"),
          url2: require("./../../assets/home/partner2/6/3.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/6/4.png"),
          url2: require("./../../assets/home/partner2/6/4.png"),
        },
        {
          url1: require("./../../assets/home/partner/6/5.jpg"),
          url2: require("./../../assets/home/partner2/6/5.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/6/6.png"),
          url2: require("./../../assets/home/partner2/6/6.png"),
        },
        {
          url1: require("./../../assets/home/partner/6/7.png"),
          url2: require("./../../assets/home/partner2/6/7.png"),
        },
        {
          url1: require("./../../assets/home/partner/6/8.png"),
          url2: require("./../../assets/home/partner2/6/8.png"),
        },
        {
          url1: require("./../../assets/home/partner/6/9.png"),
          url2: require("./../../assets/home/partner2/6/9.png"),
        },
        {
          url1: require("./../../assets/home/partner/6/10.png"),
          url2: require("./../../assets/home/partner2/6/10.png"),
        },
        {
          url1: require("./../../assets/home/partner/6/11.jpg"),
          url2: require("./../../assets/home/partner2/6/11.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/6/12.jpg"),
          url2: require("./../../assets/home/partner2/6/12.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/6/13.png"),
          url2: require("./../../assets/home/partner2/6/13.png"),
        },
        {
          url1: require("./../../assets/home/partner/6/14.jpg"),
          url2: require("./../../assets/home/partner2/6/14.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/6/15.jpg"),
          url2: require("./../../assets/home/partner2/6/15.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/6/16.jpg"),
          url2: require("./../../assets/home/partner2/6/16.jpg"),
        },
        {
          url1: require("./../../assets/home/partner/6/17.png"),
          url2: require("./../../assets/home/partner2/6/17.png"),
        },
        {
          url1: require("./../../assets/home/partner/6/18.png"),
          url2: require("./../../assets/home/partner2/6/18.png"),
        },
        {
          url1: require("./../../assets/home/partner/6/19.png"),
          url2: require("./../../assets/home/partner2/6/19.png"),
        },
        {
          url1: require("./../../assets/home/partner/6/20.png"),
          url2: require("./../../assets/home/partner2/6/20.png"),
        },
        {
          url1: require("./../../assets/home/partner/6/21.jpg"),
          url2: require("./../../assets/home/partner2/6/21.jpg"),
        },
      ],
      imgUrl: {},
    };
  },
  created() {
    this.getImgUrl();
  },
  methods: {
    getImgUrl() {
      for (let n = 0; n < this.imgs.length; n++) {
        this.$set(this.imgUrl, "url" + n, this.imgs[n].url2);
      }
      console.log("222---",this.imgUrl,"-----",this.imgs.length)
    },
    mouseover(index) {
      this.imgUrl["url" + index] = this.imgs[index].url1;
    },
    mouseout(index) {
      this.imgUrl["url" + index] = this.imgs[index].url2;
    },
  },
};
</script>

<style scoped lang="scss">
    .partner{
        background-color: #f6fafe;
        text-align: center;
        padding-top: 57px;
        padding-bottom: 34px;
        .name {
            height: 45px;
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 900;
            color: #21242A;
            line-height: 45px;
        }
        .border {
            margin: 20px auto;
            width: 27px;
            height: 3px;
            background-color: #056DFF;
        }
        .lable{
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #7c7878;
            line-height: 20px;
        }
        .content{
            max-width: 1280px;
            margin: -20px auto 0 auto;
            display: flex;
            overflow-x: auto;
            /*margin-bottom: 34px;*/
            img{
                width: 200px;
                height: 60px;
                margin: 60px 10px 44px 10px;
                &:hover{
                    border: 2px solid #055EFF;
                    width: 196px;
                    height: 56px;
                }
                /*cursor: pointer;*/
            }
        }
        ::-webkit-scrollbar {
            width: 10px;
            height: 10px;
            background: #FFFFFF;   /*可以设置轨道颜色*/
            padding-right: 2px;
        }
        ::-webkit-scrollbar-thumb {
            background: #055EFF;
            border-radius: 10px;
        }
    }
</style>
